import React from 'react'
import { useTranslation } from 'react-i18next'

import AdSetEndDateWarning from '../../../AdSetEndDateWarning'

import useStepFormStyles from '../../../../../../styles/common/stepForms'

const WarningStep = () => {
  const stepFormClasses = useStepFormStyles()

  const { t } = useTranslation()

  return (
    <>
      <div className={stepFormClasses.stepTitle}>{t('Sorry, your line item end date is in the past  ')}</div>
      <div className={stepFormClasses.stepBody}>
        <AdSetEndDateWarning />
      </div>
    </>
  )
}

export default WarningStep
